export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-background-300/60 bg-background-950">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary-500 to-transparent" />
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 py-14 md:grid-cols-2 md:px-6 lg:grid-cols-4 lg:px-8">
        <div className="lg:col-span-1">
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-open-fill text-lg" />
            </span>
            <span className="font-heading text-xl text-foreground-950">
              YY<span className="text-primary-500">漫画</span>
            </span>
          </a>
          <p className="mt-4 text-sm leading-6 text-foreground-600">
            海量免费漫画一站即读，热门连载、经典完结全集资源，下拉式翻页流畅，高清画质时刻在线。
          </p>
          <div className="mt-5 flex items-center gap-2 text-foreground-600">
            <i className="ri-mail-line text-accent-400" />
            <span className="text-sm">contact@yyfreecomic.example</span>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-bold text-foreground-950">快速导航</h3>
          <ul className="mt-4 flex flex-col gap-2.5">
            {[
              { href: '#hot', label: '热门连载' },
              { href: '#updates', label: '最新更新' },
              { href: '#ranking', label: '人气榜单' },
              { href: '#genres', label: '题材分类' },
            ].map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-sm text-foreground-600 transition hover:text-primary-400">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-bold text-foreground-950">热门题材</h3>
          <ul className="mt-4 flex flex-col gap-2.5">
            {['热血', '玄幻', '悬疑', '科幻', '恋爱'].map((g) => (
              <li key={g}>
                <a href="#updates" className="text-sm text-foreground-600 transition hover:text-primary-400">
                  {g}漫画
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-bold text-foreground-950">阅读专区</h3>
          <ul className="mt-4 flex flex-col gap-2.5">
            {[
              { href: '#feature', label: '阅读体验' },
              { href: '#faq', label: '常见问题' },
              { href: '#reading', label: '开始阅读' },
              { href: '#top', label: '返回顶部' },
            ].map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-sm text-foreground-600 transition hover:text-primary-400">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-background-300/40">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-2 px-4 py-6 text-center sm:flex-row sm:justify-between md:px-6 lg:px-8">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} YY免费漫画 · 随时随地免费追
          </p>
          <p className="text-xs text-foreground-600">下拉式翻页 · 高清画质 · 即开即读</p>
        </div>
      </div>
    </footer>
  );
}